import React from 'react';

function Footer() {
  return (
    <footer className="bg-white py-4">
      <div className="container mx-auto text-center">
        <span className="text-l font-semibold text-[#002d74]">Department of Computer Science (Artificial Intelligence & Machine Learning)</span>
      </div>
    </footer>
  );
}

export default Footer;
